// extracted by mini-css-extract-plugin
module.exports = {"appBackground":"app-background_3N4KZ","gradient":"app-background_nVYQN"};